/** @internal */
export enum SubscriberProvider {
    VAPID = 'VAPID',
    APNS = 'APNS',
}

/** @internal */
export function subscriberProviderToFriendlyString(provider: SubscriberProvider): string {
    switch (provider) {
        case SubscriberProvider.VAPID:
            return 'WebPush'
        default:
            return provider
    }
}
